export default { sha: 'c05d7f86d00c0733ad630a35ee66c9b486c21ba9', buildNumber: 'undefined' }
